import { orderType } from '../../types/order/orderType';
import { request } from '../../utils/request';

export const updateOrderStatus = ({
  authToken,
  reference,
  storeId,
  status,
}: {
  storeId: number;
  authToken: string;
  reference: orderType['reference'];
  status: 'shipped' | 'delivered' | 'cancelled';
}): Promise<any> => {
  return request({
    method: 'PATCH',
    url: `/payments/products/orders/${reference}/status`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    formData: {
      storeId,
      status,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
